module.exports = __webpack_public_path__ + "static/img/17b.2a89e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17b.jpg
// module id = /GDk
// module chunks = 0